
export const MIN_CHARS_ERROR = (number) => {
    return {
        "en": `Field too short (min ${number})`,
        "ro": `Minim ${number} caractere`,
    }
}